export default "__VITE_ASSET__DJE3rOAG__"